<template>
  <v-menu
    offset-y
    tile
    nudge-bottom="10"
    :close-on-content-click="false"
    :min-width="$vuetify.breakpoint.smAndDown ? '' : '360'"
    max-width="360"
    :content-class="isHome ? 'menuNotification' : 'menuNotification fixed'"
    v-model="showNotify"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn plain small rounded v-on="on" v-bind="attrs">
        <v-badge
          v-if="totalUnread"
          color="red"
          offset-y="8"
          dense
          :content="totalUnread"
        >
          <v-icon size="18" :color="isHome ? 'white' : 'black'">
            fas fa-bell
          </v-icon>
        </v-badge>
        <v-icon v-else size="18" :color="isHome ? 'white' : 'black'">
          fas fa-bell
        </v-icon>
      </v-btn>
    </template>
    <v-list
      :elevation="0"
      class="pt-0 menuNotification__list"
      :class="notifications.length === 0 ? '' : 'py-4'"
    >
      <template v-if="notifications.length === 0">
        <v-list-item class="pt-2">
          <translate class="px-3 grey--text"
            >You have no new notification</translate
          >
        </v-list-item>
      </template>
      <template v-else>
        <v-list-item
          class="px-4 menuNotification__item"
          v-for="(item, index) in notifications"
          :key="index"
          :style="item.status === readed ? '' : 'background: #dcdcdc'"
          @click="readNotifycation(item)"
        >
          <NotifyItem
            class="notifyItem"
            :item="item"
            @handleDelete="handleDelete"
            :status="item.status"
            @closeMenu="showNotify = false"
            @handleRead="handleRead"
            @degreeTotalUnread="totalUnread = totalUnread - 1"
            @reloadListNotify="reactiveCounter++"
          />
        </v-list-item>
        <div
          style="text-align: center;"
          class="mt-4"
          v-if="totalPages > currentPage"
        >
          <v-btn
            plain
            small
            outlined
            color="primary"
            @click="getNotificationList((currentPage += 1))"
          >
            See more
          </v-btn>
        </div>
      </template>
    </v-list>
  </v-menu>
</template>
<script>
import NotifyItem from "@/components/Notification/NotifyItem";
import NotificationService from "@/services/NotificationService";
export default {
  name: "Notification",
  components: { NotifyItem },
  data() {
    return {
      interval: null,
      currentPage: 1,
      totalPages: 1,
      total: 0,
      readed: NOTIFY_READ,
      totalUnread: 0,
      showNotify: false,
      notificationMap: {},
      reactiveCounter: 0,
    };
  },
  computed: {
    notifications() {
      const reactiveCounter = this.reactiveCounter;
      return Object.keys(this.notificationMap)
        .sort((a, b) => {
          const dateB = new Date(this.notificationMap[b].createdDate);
          const dateA = new Date(this.notificationMap[a].createdDate);
          return dateB - dateA;
        })
        .map((key) => this.notificationMap[key]);
    },
    isHome() {
      if(this.$route.name === 'homepage') return true;
      if(this.$route.name.indexOf('ranking') !== -1) return true;
      return false;
    }
  },
  methods: {
    async getNotificationList(page = 1) {
      const result = await NotificationService.listNotifications({ page });
      if (result.list && result.list.length !== 0) {
        this.totalPages = result.totalPages;
        this.totalUnread = result.totalUnread;
        if (result.currentPage > 1) {
          this.currentPage = result.currentPage;
        }
        this.transformNotificationMap(result.list);
        if (result.total > this.total && this.total > 0 && page === 1) {
          const newNotiCount = result.total - this.total;
          const newNotifications = this.notifications.slice(0, newNotiCount);
          console.log("newNotifications", newNotifications);
          document.dispatchEvent(
            new CustomEvent("newNotification", {
              detail: newNotifications,
            })
          );
        }
        this.total = result.total;
      }
    },
    transformNotificationMap(listData) {
      listData.forEach((element) => {
        this.notificationMap[element.id] = element;
      });
      this.reactiveCounter++;
    },
    clear() {
      setTimeout(clearInterval, 3000, this.interval);
    },
    handleRead(notify) {
      if (notify.status === NOTIFY_READ) return true;
      this.notificationMap[notify.id].status = NOTIFY_READ;
      this.totalUnread = this.totalUnread >= 1 ? this.totalUnread - 1 : 0;
      this.reactiveCounter++;
    },
    handleDelete(id) {
      delete this.notificationMap[id];
      this.reactiveCounter++;
    },
    async readNotifycation(notify) {
      const response = await NotificationService.readNotify(notify.id);
      if (response.error) {
        this.$toast.alert(result.error.message);
      } else {
        this.handleRead(notify);
      }
      const detail =
        (notify.entityDetail && notify.entityDetail.user) ||
        notify.notifiers[0];
      switch (notify.type) {
        case NOTIFY_NEW_POST:
          this.$router
            .push({ name: "postDetail", params: { id: notify.entityId } })
            .catch(() => {});
          break;
        case NOTIFY_GOLF_REQUEST:
          this.$emit("pickUserInChat", detail.id);
          break;
        case NOTIFIER_REPLY:
          this.$router
            .push({ name: "communityDetail", params: { id: notify.entityId } })
            .catch(() => {});
          break;
        case NOTIFIER_FOLLOW:
          const notifiers = notify.notifiers;
          this.$router
            .push({ name: "profilePerson", params: { key: notifiers[0].id } })
            .catch(() => {});
          break;
        case NOTIFIER_FRIEND_REQUEST:
          this.$emit("pickUserInChat", detail.id);
          break;
        case NOTIFY_NEW_MESSAGE:
          this.$emit("pickUserInChat", notify.notifiers[0].id);
          break;
        case NOTIFY_COMMENT:
        case NOTIFY_REPLY_COMMENT:
          this.$router
            .push({
              name: "postDetail",
              params: {
                id: notify.entityDetail.postId,
                commentId: notify.entityId,
              },
            })
            .catch(() => {});
          break;
      }
      this.showNotify = false;
    },
  },
  async mounted() {
    await this.getNotificationList();
    clearInterval(this.interval);
    this.interval = setInterval(
      async () => await this.getNotificationList(),
      60000
    );
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  watch: {
    showNotify(val) {
      if(this.$vuetify.breakpoint.smAndDown) {
        let html = document.querySelector("html");
        if(val) {
          html.style.overflow = "hidden";
        } else {
          html.style.overflow = "auto";
        }
      }
    }
  }
};
</script>
